import React from 'react';

import Paths from './Paths';
import getNewIcon from './getNewIcon';

function Icons({ width = 24, height = 24, name, ...rest }) {
  const newIcon = getNewIcon({ name, ...rest });
  if (newIcon) {
    return newIcon;
  }

  const path = Paths?.[name];
  return (
    <svg viewBox="0 0 24 24" width={width} height={height} {...rest}>
      <g>
        <path d={path} />
      </g>
    </svg>
  );
}

export default Icons;
